export const OFFLINE_PAYMENT_REQUEST = "OFFLINE_PAYMENT_REQUEST";
export const OFFLINE_PAYMENT_SUCCESSS = "OFFLINE_PAYMENT_SUCCESSS";
export const OFFLINE_PAYMENT_FAILED = "OFFLINE_PAYMENT_FAILED";
